export const DELIVERY_POINT_TYPE = {
  RELAY: 'relay',
  ECO: 'eco',
  ENTREPRISE: 'entreprise',
  CONCIERGERIE: 'conciergerie',
} as const;

export type DeliveryPointType = typeof DELIVERY_POINT_TYPE[keyof typeof DELIVERY_POINT_TYPE];

export type DeliveryPointAddress = {
  street: string;
  zipCode: string;
  city: string;
  country?: string;
  informations?: string;
};

export type DeliveryPointScheduleSlot = {
  from: string;
  to: string;
};

export type DeliveryPointSchedule = {
  day: string;
  pickup: DeliveryPointScheduleSlot;
  deposit?: DeliveryPointScheduleSlot;
};

export type DeliveryPointSegment = {
  id: string;
  name: string;
};

export interface DeliveryPoint {
  id: string;
  name: string;
  type: DeliveryPointType;
  phone?: string;
  email?: string;
  segment?: DeliveryPointSegment;
  address: DeliveryPointAddress;
  isActive: boolean;
  archivedAt: string | null;
}

export type GetDeliveryPointsResponse = {
  totalCount: number;
  deliveryPoints: DeliveryPoint[];
};

export type DeliveryPointSortColumn = 'name' | 'type' | 'createdAt';

export type DeliveryPointSortDirection = 'asc' | 'desc';

export type GetDeliveryPointsFilters = {
  name?: string;
  type?: DeliveryPointType;
  segment?: string;
  isActive?: boolean;
  archived?: boolean;
};

export type GetDeliveryPointsParams = {
  page?: number;
  limit?: number;
  sortBy?: DeliveryPointSortColumn;
  sortDirection?: DeliveryPointSortDirection;
  filters?: GetDeliveryPointsFilters;
};
